module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAATCAYAAACtHkzTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABuSURBVHgB3Y/RDYAwCESpYQBHcAMdwVE6ghvaDXQD2QRJpEoNpomffckFQhvuADAw8yza+CGieRykrPCiM/0CDmj60fRJRKrb4sjGXxYuqOEK8iyEQMVqh1i1qGcQ7XCdM4l6nSetZIP9O7ONDyfoA1r2JIQo4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fb.png
// module id = 1426
// module chunks = 0